import { render, staticRenderFns } from "./confirmar_identidad2.vue?vue&type=template&id=4af6cad6&scoped=true"
import script from "./confirmar_identidad2.vue?vue&type=script&lang=js"
export * from "./confirmar_identidad2.vue?vue&type=script&lang=js"
import style0 from "./confirmar_identidad2.vue?vue&type=style&index=0&id=4af6cad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6cad6",
  null
  
)

export default component.exports